module.exports = __webpack_public_path__ + "img/digital_assistant.e109fe36.png";